import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { navigate, openDialog, hideDialog } from '../../actions';
import { getMaquinas, deleteMaquinaDB } from '../../actions/maquina_detalle_actions';
import { getTiposMaquina } from '../../actions/tipos_maquina_actions';
import { getModelosMaquina } from '../../actions/modelos_maquina_actions';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import CircularProgress from '@material-ui/core/CircularProgress';

import * as config from '../../constants/configuration';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    bottomBtn: {
        position: 'absolute',
        right: '0',
        bottom: '0',
        margin: theme.spacing(1)
    },
    button: {
        margin: theme.spacing(1)
    },
    group: {
        margin: `${theme.spacing(1)}px 0`,
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class MaeMaquina extends Component {

    constructor(props) {
        super(props);

        this.state = {
            estado_maquinas: 'vmaquinasalta',
            noSpinner: !this.props.noSpinner ? false : true,
        }

    };

    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

        this.props.getMaquinas(this.state.estado_maquinas);
        this.props.getTiposMaquina();
        this.props.getModelosMaquina();

    };

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.maeMaquinas !== this.props.maeMaquinas) this.setState({ noSpinner: true})

        if (prevState.estado_maquinas !== this.state.estado_maquinas) {
            this.props.getMaquinas(this.state.estado_maquinas);
            this.setState({noSpinner: false})
        }

        if (this.props.refresh) {
            this.props.getMaquinas(this.state.estado_maquinas);
        }
    };

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    }

    editMaquina = (maquina) => {
        this.props.navigate("edit_maquina/" + maquina.id);
    };

    newMaquina = () => {
        this.props.navigate("edit_maquina/" + -1);
    };


    checkNewMaquina = (maquina) => {
        if (this.props.maeMaquinas.find(z => (z.descr === maquina.descr) && (z.id !== maquina.id))) {
            return false;
        }
        return true;
    };


    deleteMaquina = (maquina) => {
        this.props.openDialog('ConfirmationDialog', {
            message: '¿Desea borrar definitivamente la máquina ' + this.props.maeMaquinas.find(c => c.id === maquina.id).descr + '? \n NO es posible deshacer esta operación',
            acceptHandler: () => {
                this.props.deleteMaquinaDB(maquina.id);
            }
        }, uuidv4(), false, 'sm');
        
    };


    render() {

        const { classes } = this.props;

        return (

            <div className={classes.root}>
                <div className={classes.toolbar} />

                <FormControl component="fieldset" className={classes.formControl}>
                    <RadioGroup
                        name="estadoMaquinas"
                        className={classes.group}
                        value={this.state.estado_maquinas}
                        onChange={(event) => this.handleValueChange(event, 'estado_maquinas')}
                    >
                        <FormControlLabel value="vmaquinasalta" control={<Radio />} label="Maquinas de alta" />
                        <FormControlLabel value="vmaquinasbaja" control={<Radio />} label="Maquinas de baja" />
                    </RadioGroup>
                </FormControl>

                {this.props.tiposMaquina && this.props.modelosMaquina && this.props.maeMaquinas && this.state.noSpinner ?
                    <NeuriteGrid
                    id="m_m"
                        columns={[
                            { key: 'descr', name: 'Nombre', editable: false, dragable: false, width: 110 },
                            { key: 'regInterno', name: 'RegInterno', editable: false, dragable: false, width: 80 },
                            { key: 'matricula', name: 'Matricula', editable: false, dragable: false, width: 80 },
                            { key: 'tipo', name: 'Tipo', editable: false, dragable: false, width: 75 },
                            { key: 'modelo', name: 'Modelo', editable: false, dragable: false, width: 100 },
                            { key: 'centro', name: 'Centro', editable: false, dragable: false, width: 105 },
                            { key: 'fechaCompra', name: 'Fecha Compra', editable: false, dragable: false, width: 85, type: 'date' },
                            { key: 'fechaBaja', name: 'Fecha Baja', editable: false, dragable: false, width: 80, type: 'date' },                            
                            { key: 'activa', name: 'Activa', type: 'bool', dragable: false, width: 52 },
                            { key: 'comentarios', name: 'Comentarios', editable: false, dragable: false, width: 80 },
                            { key: 'regaloDirecto', name: 'RegaloDirecto', type: 'bool', dragable: false, width: 85 },
                        ]}
                        rows={this.props.maeMaquinas}
                        buttonEdit={true}
                        buttonDelete={true}
                        buttonNew={true}
                        height={500}
                        onNewRowClick={this.newMaquina}
                        onEditClick={this.editMaquina}
                        onDeleteClick={this.deleteMaquina}
                        enableFilter={true}
                    />
                    : <div className={classes.spinnerContainer}> <CircularProgress className={classes.spinner} color="secondary" /> </div>}
            </div>
        );

    };

};

MaeMaquina.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    noSpinner: PropTypes.bool.isRequired,
    refresh: PropTypes.bool.isRequired,
    maeMaquinas: PropTypes.array.isRequired,
    tiposMaquina: PropTypes.object.isRequired,
    modelosMaquina: PropTypes.object.isRequired,

    //dispatch
    getMaquinas: PropTypes.func.isRequired,
    getTiposMaquina: PropTypes.func.isRequired,
    getModelosMaquina: PropTypes.func.isRequired,
    navigate: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    deleteMaquinaDB: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        maeMaquinas: state.maeMaquinas.maquinas,
        refresh: state.maeMaquinas.refresh,
        noSpinner: state.maeMaquinas.noSpinner,
        tiposMaquina: state.tiposMaquina,
        modelosMaquina: state.modelosMaquina,
    };
}

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        navigate,
        getMaquinas,
        getTiposMaquina,
        getModelosMaquina,
        openDialog,
        hideDialog,
        deleteMaquinaDB,
    }, dispatch);
}

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(MaeMaquina));
